import React, { useState } from 'react';
import { Box, Collapse, IconButton, Typography } from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import JsonDiffViewer from './JsonDiffViewer';
import { reviewerEditDiff } from '../utils/reviewerEdit';

export const REVIEWER_EDIT_TITLE = 'AI fix vs final (edited by reviewer)';
const AI_LABEL = 'AI fix';
const FINAL_LABEL = 'Final (edited by reviewer)';

/**
 * DPS-4718: on a job approved with edits, the agent's proposed config next to
 * what the reviewer approved. Renders nothing when there was no edit.
 */
export default function ReviewerEditDiff({ ctx }) {
  const [open, setOpen] = useState(true);
  const diff = reviewerEditDiff(ctx);
  if (!diff) return null;

  return (
    <Box data-testid="reviewer-edit-diff" sx={{ borderTop: '1px solid rgba(255,255,255,0.04)' }}>
      <Box
        onClick={() => setOpen((o) => !o)}
        sx={{
          display: 'flex', alignItems: 'center', gap: 1, cursor: 'pointer', py: 1.25, px: 3,
          '&:hover': { background: 'rgba(255,255,255,0.015)' },
        }}
      >
        <IconButton size="small" aria-label={open ? 'Hide reviewer edits' : 'Show reviewer edits'} sx={{ color: '#475569', p: 0 }}>
          {open ? <ExpandLessIcon sx={{ fontSize: 16 }} /> : <ExpandMoreIcon sx={{ fontSize: 16 }} />}
        </IconButton>
        <Typography sx={{ color: '#94a3b8', fontWeight: 500, fontSize: '0.8rem', flex: 1 }}>
          {REVIEWER_EDIT_TITLE}
        </Typography>
        {diff.summary && (
          <Typography sx={{ color: '#475569', fontSize: '0.72rem' }}>{diff.summary}</Typography>
        )}
      </Box>
      <Collapse in={open}>
        <Box sx={{ px: 3, pb: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
          {diff.config && (
            <JsonDiffViewer
              oldConfig={diff.config.ai}
              newConfig={diff.config.final}
              title="Extraction config"
              oldLabel={AI_LABEL}
              newLabel={FINAL_LABEL}
            />
          )}
          {diff.parsed && (
            <JsonDiffViewer
              oldConfig={diff.parsed.ai}
              newConfig={diff.parsed.final}
              title="Parsed config"
              oldLabel={AI_LABEL}
              newLabel={FINAL_LABEL}
            />
          )}
        </Box>
      </Collapse>
    </Box>
  );
}
